"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-martino-di-venezze": {
    "c8832cfe": [{
      "hkey": "992884b9",
      "slug": "san-martino-di-venezze",
      "name": "San Martino di Venezze",
      "primary": true,
      "skipSearch": false
    }],
    "borghi-saline": [{
      "hkey": "992884b9",
      "slug": "san-martino-di-venezze",
      "name": "San Martino di Venezze",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "20a807a7": [{
      "hkey": "992884b9",
      "slug": "san-martino-di-venezze",
      "name": "San Martino di Venezze",
      "primary": true,
      "skipSearch": false
    }],
    "ca-redetti": [{
      "hkey": "992884b9",
      "slug": "san-martino-di-venezze",
      "name": "San Martino di Venezze",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d94e2611": [{
      "hkey": "992884b9",
      "slug": "san-martino-di-venezze",
      "name": "San Martino di Venezze",
      "primary": true,
      "skipSearch": false
    }],
    "ca-venezze": [{
      "hkey": "992884b9",
      "slug": "san-martino-di-venezze",
      "name": "San Martino di Venezze",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;